export default __webpack_public_path__ + "static/media/circle-check.61465218.jpg";